import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "col-12 pt-3" }
const _hoisted_2 = { class: "title-2 w-100 pb-2 pb-md-4 text-grey-900" }
const _hoisted_3 = { class: "row pt-0 pt-md-5" }
const _hoisted_4 = { class: "col-12 col-md-5" }
const _hoisted_5 = { class: "d-inline justify-content-start" }
const _hoisted_6 = { class: "d-none d-md-block justify-content-between" }
const _hoisted_7 = {
  key: 0,
  class: "title-3 text-grey-900 pt-2 pb-4"
}
const _hoisted_8 = {
  class: "d-md-none w-100 py-3 py-3",
  "data-toggle": "collapse",
  type: "button",
  "data-target": "#tf-desc-station-inner",
  "aria-expanded": "false",
  "aria-controls": "tf-desc-inner"
}
const _hoisted_9 = { class: "d-flex justify-content-between border-top border-gray py-2" }
const _hoisted_10 = {
  key: 0,
  class: "title-3 text-grey-900 pt-2"
}
const _hoisted_11 = {
  "data-mobile-collapsed": "",
  "data-desktop-expanded": "",
  id: "tf-desc-station-inner",
  class: "collapse pt-2 pt-md-3"
}
const _hoisted_12 = {
  ref: "stationDescText",
  id: "stationDescText"
}
const _hoisted_13 = {
  key: 0,
  class: "body text-grey-900 show-more-less-text"
}
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 1,
  class: "title-3 text-grey-900 show-more-less-text"
}
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  style: {"color":"var(--primary-blue)"},
  width: "10",
  height: "10",
  class: "icon"
}
const _hoisted_18 = {
  key: 1,
  class: "col-12 col-md-7"
}
const _hoisted_19 = {
  key: 0,
  class: "d-inline justify-content-start"
}
const _hoisted_20 = { class: "d-none d-md-block justify-content-between" }
const _hoisted_21 = { class: "title-3 text-grey-900 pt-2 pb-4" }
const _hoisted_22 = {
  class: "d-md-none w-100 py-3 py-3",
  "data-toggle": "collapse",
  type: "button",
  "data-target": "#tf-desc-station-adv-inner",
  "aria-expanded": "false",
  "aria-controls": "tf-desc-station-adv-inner"
}
const _hoisted_23 = { class: "d-flex justify-content-between py-2 border-top border-gray" }
const _hoisted_24 = { class: "title-3 text-grey-900 pt-2" }
const _hoisted_25 = {
  key: 1,
  id: "tf-desc-station-adv-inner",
  class: "collapse pt-2 pt-md-3",
  "data-mobile-collapsed": "",
  "data-desktop-expanded": ""
}
const _hoisted_26 = {
  key: 0,
  class: "media d-flex pb-1"
}
const _hoisted_27 = { class: "media-body" }
const _hoisted_28 = { class: "mt-0 body-strong text-grey-900 font-weight-600" }
const _hoisted_29 = { class: "caption text-grey-900" }
const _hoisted_30 = {
  key: 1,
  class: "media d-flex pb-1"
}
const _hoisted_31 = { class: "media-body" }
const _hoisted_32 = { class: "mt-0 body-strong text-grey-900 font-weight-600" }
const _hoisted_33 = { class: "caption text-grey-900" }
const _hoisted_34 = {
  key: 2,
  class: "media d-flex pb-1"
}
const _hoisted_35 = { class: "media-body" }
const _hoisted_36 = { class: "mt-0 body-strong text-grey-900 font-weight-600" }
const _hoisted_37 = { class: "caption text-grey-900" }
const _hoisted_38 = {
  key: 3,
  class: "media d-flex pb-1"
}
const _hoisted_39 = { class: "media-body" }
const _hoisted_40 = { class: "mt-0 body-strong text-grey-900 font-weight-600" }
const _hoisted_41 = { class: "caption text-grey-900" }
const _hoisted_42 = {
  key: 4,
  class: "media d-flex pb-1"
}
const _hoisted_43 = { class: "media-body" }
const _hoisted_44 = { class: "mt-0 body-strong text-grey-900 font-weight-600" }
const _hoisted_45 = { class: "caption text-grey-900" }

import { computed, onMounted, onUnmounted, reactive, watch } from "vue";
// components
// import Map from "@/vue/station-domain/components/map/map.vue";
import PopupBase from "@/vue/common/popupBase.vue";
import StationBanner from "@/vue/station-domain/components/StationBanner.vue";
import DomainsSection from "@/vue/station-domain/components/DomainsInformationSection/DomainsSection.vue"
import StationPopupContent from "@/vue/station-domain/components/stationPopupContent.vue";
import { CustomWindowEvents } from "@/enums/customWindowEvents";

type StationData = Record<string, any>;


export default /*@__PURE__*/_defineComponent({
  __name: 'station',
  props: {
    locale: {},
    stationData: {}
  },
  setup(__props: any) {

const props = __props;

const w = window as Window & {
	content?: any;
	lihe?: { stationId?: string };
	seasonManager?: { season?: string };
};

const stationId = w.lihe?.stationId ?? "";

const data = reactive({
	stationData: null as StationData | null,
	textShowMoreLess: null as unknown,
});

const state = reactive({
	popupOpen: false,
	season: w.seasonManager?.season ?? "",
});

const content = computed(() => w.content);
const season = computed(() => state.season);

const descriptionText = computed(() => {
	if (!props.stationData?.description) return "";
	return props.stationData.description as string;
});

const infoText = computed(() => {
	return season.value === "H"
		? (props.stationData?.infoWinter ?? "")
		: (props.stationData?.infoWSummer ?? "");
});

function handleClosePopup() {
	state.popupOpen = false;
}

function handleOpenPopup() {
	state.popupOpen = true;
}

function onSeasonChange() {
	state.season = w.seasonManager?.season ?? "";

	const merchSection = document.querySelector("section.tf-merchandising");
	if (merchSection && window.seasonManager.isSummer()) { // TEMPORARY - disable and remove merch for summer until a solution is found
		// console.log(`hiding merch on summer`)
		merchSection.classList.add("d-none")
		// merchSection.remove() // TODO change to display none
	}
	else if (merchSection && !window.seasonManager.isSummer()) {
		merchSection.classList.remove("d-none")
	}


}

onMounted(() => {
	window.addEventListener(CustomWindowEvents.CHANGE_SEASON, onSeasonChange);
});

onUnmounted(() => {
	window.removeEventListener(CustomWindowEvents.CHANGE_SEASON, onSeasonChange);
});

return (_ctx: any,_cache: any) => {
  return (_ctx.stationData)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(season.value === 'E' && 'col-12 px-xl-0'),
        id: "station-wrapper",
        ref: "station-wrapper"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h2", _hoisted_2, _toDisplayString(content.value.station_aboutTheStation) + " " + _toDisplayString(_ctx.stationData.name), 1),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.locale === 'fr_FR')
              ? (_openBlock(), _createBlock(StationBanner, {
                  key: 0,
                  parentStationId: _ctx.stationData.parentStationId,
                  stationId: _unref(stationId)
                }, null, 8, ["parentStationId", "stationId"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (infoText.value)
                    ? (_openBlock(), _createElementBlock("h3", _hoisted_7, _toDisplayString(content.value.station_GoTo) + " " + _toDisplayString(_ctx.stationData.name), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("a", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    (infoText.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(content.value.station_GoTo) + " " + _toDisplayString(_ctx.stationData.name), 1))
                      : _createCommentVNode("", true),
                    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex d-sm-none align-items-center\"><svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" class=\"bi bi-chevron-up\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4 10L8 6L12 10\" stroke=\"#1D2329\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg><svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" class=\"bi bi-chevron-down\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 6L8 10L4 6\" stroke=\"#1D2329\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></div>", 1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  (infoText.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("p", { innerHTML: infoText.value }, null, 8, _hoisted_14)
                      ]))
                    : (_ctx.stationData.pratique)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("p", {
                            class: "popup-content-text body text-grey-900",
                            innerHTML: _ctx.stationData.pratique
                          }, null, 8, _hoisted_16)
                        ]))
                      : _createCommentVNode("", true)
                ], 512),
                (infoText.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: _withModifiers(handleOpenPopup, ["stop"]),
                      id: "description-show-more",
                      class: "link-large-underline link-default py-3 cursor-pointer"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(content.value.station_FullDescription), 1),
                      (_openBlock(), _createElementBlock("svg", _hoisted_17, _cache[1] || (_cache[1] = [
                        _createElementVNode("use", { "xlink:href": "#___icon___chevron-right-bold" }, null, -1)
                      ])))
                    ]))
                  : _createCommentVNode("", true),
                (infoText.value)
                  ? (_openBlock(), _createBlock(PopupBase, {
                      key: 1,
                      open: state.popupOpen,
                      onClosePopup: handleClosePopup
                    }, {
                      default: _withCtx(() => [
                        _createVNode(StationPopupContent, {
                          stationData: _ctx.stationData,
                          onHandleClosePopup: handleClosePopup
                        }, null, 8, ["stationData"])
                      ]),
                      _: 1
                    }, 8, ["open"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (season.value === 'H')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  (_ctx.stationData.reason1body)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("h3", _hoisted_21, _toDisplayString(content.value.station_WhyGoTo) + " " + _toDisplayString(_ctx.stationData.name) + "? ", 1)
                        ]),
                        _createElementVNode("a", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, _toDisplayString(content.value.station_WhyGoTo) + " " + _toDisplayString(_ctx.stationData.name) + "? ", 1),
                            _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"d-flex d-sm-none align-items-center\"><svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" class=\"bi bi-chevron-up\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4 10L8 6L12 10\" stroke=\"#1D2329\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg><svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" class=\"bi bi-chevron-down\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 6L8 10L4 6\" stroke=\"#1D2329\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></div>", 1))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
							_ctx.stationData.reason1body ||
							_ctx.stationData.reason2body ||
							_ctx.stationData.reason3body ||
							_ctx.stationData.reason4body ||
							_ctx.stationData.reason5body
						)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        (_ctx.stationData.reason1body)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "tf-lihe-icons-wrap me-2" }, [
                                _createElementVNode("svg", {
                                  width: "14",
                                  height: "10",
                                  class: "icon text-primary-blue"
                                }, [
                                  _createElementVNode("use", { href: "#___icon___check" })
                                ])
                              ], -1)),
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.stationData.reason1title), 1),
                                _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.stationData.reason1body), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.stationData.reason2body)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "tf-lihe-icons-wrap me-2" }, [
                                _createElementVNode("svg", {
                                  width: "14",
                                  height: "10",
                                  class: "icon text-primary-blue"
                                }, [
                                  _createElementVNode("use", { href: "#___icon___check" })
                                ])
                              ], -1)),
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.stationData.reason2title), 1),
                                _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.stationData.reason2body), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.stationData.reason3body)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "tf-lihe-icons-wrap me-2" }, [
                                _createElementVNode("svg", {
                                  width: "14",
                                  height: "10",
                                  class: "icon text-primary-blue"
                                }, [
                                  _createElementVNode("use", { href: "#___icon___check" })
                                ])
                              ], -1)),
                              _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.stationData.reason3title), 1),
                                _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.stationData.reason3body), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.stationData.reason4body)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "tf-lihe-icons-wrap me-2" }, [
                                _createElementVNode("svg", {
                                  width: "14",
                                  height: "10",
                                  class: "icon text-primary-blue"
                                }, [
                                  _createElementVNode("use", { href: "#___icon___check" })
                                ])
                              ], -1)),
                              _createElementVNode("div", _hoisted_39, [
                                _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.stationData.reason4title), 1),
                                _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.stationData.reason4body), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.stationData.reason5body)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "tf-lihe-icons-wrap me-2" }, [
                                _createElementVNode("svg", {
                                  width: "14",
                                  height: "10",
                                  class: "icon text-primary-blue"
                                }, [
                                  _createElementVNode("use", { href: "#___icon___check" })
                                ])
                              ], -1)),
                              _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.stationData.reason5title), 1),
                                _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.stationData.reason5body), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode(DomainsSection, {
              data: data,
              stationData: _ctx.stationData,
              descriptionText: descriptionText.value,
              season: season.value
            }, null, 8, ["data", "stationData", "descriptionText", "season"])
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})